/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
import "rsuite/DatePicker/styles/index.css";

import { useEffect, useState, useMemo } from "react";
import { DateRangePicker } from "rsuite";
import { SubmitButton as Button } from "~/components/form/submit-button";
import {
  getReports,
  getAdminMenuItems,
  getClientMenuItems,
  getSupervisorMenuItems,
  getBusinessRulesMenuItems,
} from "~/services/supervisor.services";

import ReportTable from "./table";
import { Timeout } from "node_modules/@tanstack/react-router/dist/esm/utils";
import { ISidebarMenuItem } from "~/types/agent-types";
import { reportsRoute } from "~/pages/all-routes";
import { convertSecondsToHHMMSS } from "~/utils/basic";
import { toast } from "react-toastify";
type CustomResult = ISidebarMenuItem & {
  schema?: {
    result?: Array<{
      fields: Array<{ id: string; label: string }>;
    }>;
  };
};
const ReportComponent = () => {
  const { name } = reportsRoute.useSearch();
  const [sidebarItems, setSidebarItems] = useState<ISidebarMenuItem[]>([]);
  const [worklistData, setWorklistData] = useState<any[]>([]);
  const [tableFields, setTableFields] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [statusCheckInterval, setStatusCheckInterval] = useState<
    number | null | Timeout
  >(null);
  const [intervalClearTimeOut, setIntervalClearTimeOut] = useState<number>(0);

  const handleDateRangeChange = (value: [Date | null, Date | null]) => {
    setDateRange(value);
  };

  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const reportType = name;
  const getReportName = (reportType: string) => {
    if (reportType === "invoice_accuracy") {
      return "Invoice Accuracy Report";
    } else if (reportType === "header_accuracy") {
      return "Header Accuracy Report";
    } else if (reportType === "output_files") {
      return "Output Files";
    } else if (reportType === "milestones_dashboard") {
      return "Milestones Dashboard";
    } else if (reportType === "reference_accuracy") {
      return "Reference Number Accuracy Report";
    } else if (reportType === "accessorial_accuracy") {
      return "Accessorials Accuracy Report";
    } else {
      return "Accuracy Report";
    }
  };

  // Memoize the resultSchema from sidebarItems and reportType
  const resultSchema = useMemo(() => {
    const matched = sidebarItems
      .flatMap((item) => item.subMenu || [])
      .find((sub) => sub.id === reportType) as CustomResult | undefined;
      console.log("Kiran ", matched?.schema?.result);
    return matched?.schema?.result?.[0]?.fields || [];
  }, [sidebarItems, reportType]);
  const fetchData = async (fromDate: any, toDate: any) => {
    if (!fromDate || !toDate) return;

    setIsLoading(true);
    setIsDisabled(!isDisabled);
    // Format 'fromDate' in dd/MM/yyyy
    const fromStr = fromDate.toLocaleDateString("en-GB"); // en-GB uses dd/MM/yyyy format
    // Format 'toDate' in dd/MM/yyyy
    const toStr = toDate.toLocaleDateString("en-GB"); // en-GB uses dd/MM/yyyy format

    console.log(fromStr, toStr);
    const queryString = `name=${name}&fromdate=${fromStr}&todate=${toStr}`;

    try {
      const scheduledReportsResponse = await getReports(
        `scheduled-reports?${queryString}`
      );
      console.log(scheduledReportsResponse.data.data);

      if (scheduledReportsResponse.data.data === "success") {
        console.log("moving to step 2");
        const intervalId = setInterval(async () => {
          const statusQuery = new URLSearchParams({
            name,
          }).toString();

          const statusResponse = await getReports(
            `scheduled-reports/status?${statusQuery}`
          );
          console.log(statusResponse.data.data);

          if (statusResponse.data.data === "Complete") {
            clearInterval(intervalId);

            const dataQuery = new URLSearchParams({
              name,
            }).toString();

            const dataResponse = await getReports(
              `scheduled-reports/data?${dataQuery}`
            );
            console.log(dataResponse.data.data);

            if (dataResponse.status) {
              const dataUrl = dataResponse.data.data;

              try {
                const response = await fetch(dataUrl);
                const jsonData = await response.json();
                console.log(jsonData);
                const tableData =
                  jsonData?.dbdata?.report?.reportentity1 ||
                  jsonData?.dbdata?.report?.reportentity2 ||
                  jsonData?.dbdata?.report?.reportentity3 ||
                  [];
                console.log(tableData);

                const fieldMapping = resultSchema.reduce(
                  (
                    acc: Record<string, string>,
                    field: { id: string; label: string }
                  ) => {
                    acc[field.id] = field.label;
                    return acc;
                  },
                  {}
                );
                const keysToConvert = ["aging", "overalltat"];
                const mappedTableData = tableData.map((row: any) => {
                  const mappedRow: Record<string, any> = {};
                  for (const [key, value] of Object.entries(row)) {
                    if (keysToConvert.includes(key)) {
                      const convertedValue = convertSecondsToHHMMSS(
                        Number(value)
                      );
                      mappedRow[fieldMapping[key]] = convertedValue;
                    } else {
                      mappedRow[fieldMapping[key] || key] = value;
                    }
                  }
                  return mappedRow;
                });

                const fields = resultSchema.map(
                  (field: { label: any }) => field.label
                );
                setTableFields(fields);
                console.log(fields);
                setWorklistData(mappedTableData);
              } catch (error) {
                console.error("Error fetching JSON data:", error);
              }
            } else {
              console.error("Failed to fetch reports:", dataResponse.error);
            }
            setIsLoading(false);
            setIsDisabled(isDisabled);
          }
          if(statusResponse.data.data === "In-Process"){
            setIntervalClearTimeOut((prev) => prev + 1);
          }
        }, 5000);

        setStatusCheckInterval(intervalId);
      } else {
        console.error(
          "Failed to fetch scheduled reports:",
          scheduledReportsResponse.error
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      setIsLoading(false);

      setIsDisabled(false);
    }
  };

  // Fetch sidebar items on mount
  useEffect(() => {
    const roleid = localStorage.getItem("roleid");

    async function fetchSidebarItems() {
      let response;

      switch (roleid) {
        case "12":
          response = await getAdminMenuItems("admin_menu_items");
          break;
        case "8":
          response = await getClientMenuItems("client_menu_items");
          break;
        case "16":
          response = await getBusinessRulesMenuItems(
            "business_rule_menu_items"
          );
          break;
        case "3":
        default:
          response = await getSupervisorMenuItems("supervisor_menu_items");
          break;
      }

      if (response?.status) {
        const items = response.data?.data?.menu_items ?? response.data ?? [];
        setSidebarItems(items);
      } else {
        setSidebarItems([]);
      }
    }

    fetchSidebarItems();
  }, []);

  // Clear worklist and reset states when report type changes
  useEffect(() => {
    setWorklistData([]);
    setDateRange([null, null]);
    setIsDisabled(false);
    setIsLoading(false);
  }, [name]);

  // Cleanup interval on unmount or when it changes
  useEffect(() => {
    return () => {
      if (statusCheckInterval) clearInterval(statusCheckInterval);
    };
  }, [statusCheckInterval]);

  useEffect(() => {
    if(intervalClearTimeOut >=120 && statusCheckInterval){
      clearInterval(statusCheckInterval);
      setIsLoading(false);
      setIsDisabled(false);
      setIntervalClearTimeOut(0);
      //console.log("Interval cleared after 120 attempts");
      toast.error("Something went wrong, Please try again", {
              theme: "colored",
            });
    }
  }, [intervalClearTimeOut]);
  return (
    <div>
      <div className="mb-4 ">
        <div className="flex justify-between items-center mb-3">
          <h4 className="text-2xl font-semibold text-orange-500">
            {getReportName(name)}
          </h4>
          <div className="flex flex-wrap gap-4 items-end">
            <div className="flex flex-col">
              <DateRangePicker
                showOneCalendar
                onChange={handleDateRangeChange as any}
                format="dd/MM/yyyy"
                value={dateRange as any}
                placeholder="Please Select the date range"
                disabled={isDisabled}
              />
            </div>

            <Button
              className="h-10 ml-4"
              role="button"
              variant="primary"
              size="small"
              onClick={async () => fetchData(dateRange[0], dateRange[1])}
              disabled={isDisabled}
            >
              Search
            </Button>
          </div>
        </div>
      </div>

      <div className="bg-neutral-100 rounded-lg">
        <div className="p-2">
          {isLoading && name === reportType ? (
            <div className="flex flex-col items-center justify-center h-48">
              <div className="spinner-border animate-spin border-4 border-orange-400 border-t-transparent w-12 h-12 rounded-full"></div>
              <p className="mt-2 text-lg">
                Please wait...
                <br />
                Generating reports may take some while
              </p>
            </div>
          ) : worklistData.length > 0 ? (
            <ReportTable
              data={worklistData}
              fields={tableFields}
              reportname={name}
            />
          ) : (
            <p className="text-center text-lg">
              Please select a valid date range to fetch reports
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default ReportComponent;
